import classNames from 'classnames';
import { pickDomAttrs } from '../_util/utils';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Explain = props => {
  const {
    type = 'error',
    helperText,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    wrapClassName,
    wrapStyle,
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-explain");
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: wrapClassName,
    style: wrapStyle,
    children: [children, /*#__PURE__*/_jsx("div", {
      className: classNames(className, baseClassName, type, {
        active: !!helperText
      }),
      style: style,
      children: !!helperText && /*#__PURE__*/_jsx("div", {
        children: helperText
      })
    })]
  });
};
export default Explain;